import get from 'lodash/get';

import * as constants from '../../constants';
import { getParsedGatewayDetails } from './responseParser';

const initialState = {
  hasError: false,
  isLoading: false,
  pageErrors: [],
  proxyDetails: {},
  gatewayDetails: {},
  gateways: [],
  proxyApis: {
    apis: 0,
    apisPendingDeployment: 0,
    apisDeployed: 0,
    apisError: 0,
    apisPublishedByPortal: 0,
    apisPublishedByPortalPendingDeployment: 0,
    apisPublishedByPortalDeployed: 0,
    apisPublishedByPortalError: 0,
    apisPublishedByGateway: 0,
    apisPublishedByGatewayPendingDeployment: 0,
    apisPublishedByGatewayDeployed: 0,
    apisPublishedByGatewayError: 0,
    apisPendingUndeployment: 0,
    apisPublishedByPortalPendingUndeployment: 0,
    apisPublishedByGatewayPendingUndeployment: 0,
    apisErrorUndeploy: 0,
    apisPublishedByPortalErrorUndeploy: 0,
    apisPublishedByGatewayErrorUndeploy: 0,
  },
  apis: {
    apis: {},
    apisPublishedByGateway: {},
    apisPublishedByPortal: {},
  },
  apps: [],
  organizations: {},
  apiPlans: {},
  accountPlans: {},
  apisList: {
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
  keysList: {
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
  apiKeys: {
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.API_PROXY_LOADING:
      return {
        ...state,
        hasError: false,
        pageErrors: [],
        isLoading: action.payload,
      };
    case constants.API_PROXY_RESET:
      return {
        ...initialState,
        isProxyDeleteSuccess: false,
      };
    case constants.PROXY_GET_SUCCESS:
      return {
        ...state,
        proxyDetails: get(action.payload, 'proxyDetails'),
        proxy: get(action.payload, 'proxy'),
        fetchProxyStatus: constants.SUCCESS,
        hasError: false,
        pageErrors: [],
      };
    case constants.PROXY_GET_ERROR:
      return {
        ...state,
        proxyUuid: '',
        proxyDetails: {},
        fetchProxyStatus: constants.FAIL,
        hasError: true,
        pageErrors: action.payload,
      };
    case constants.PROXY_DELETE_SUCCESS:
      return {
        ...state,
        hasError: false,
        pageErrors: [],
        isProxyDeleteSuccess: true,
      };
    case constants.PROXY_DELETE_ERROR:
      return {
        ...state,
        hasError: true,
        pageErrors: action.payload,
        isProxyDeleteSuccess: false,
      };
    case constants.PROXY_DETAILS_GET_SUCCESS:
      return {
        ...state,
        proxyDetails: action.payload,
        hasError: false,
        pageErrors: [],
      };
    case constants.PROXY_DETAILS_GET_ERROR:
      return {
        ...state,
        proxyDetails: {},
        hasError: true,
        pageErrors: action.payload,
      };
    case constants.PROXY_GATEWAY_GET_REQUEST:
      return {
        ...state,
        gatewayDetailsLoading: true,
        isLoading: true,
        hasError: false,
        pageErrors: [],
      };
    case constants.PROXY_GATEWAY_GET_SUCCESS:
      return {
        ...state,
        gatewayDetailsLoading: false,
        isLoading: false,
        gatewayDetails: action.payload.gatewayDetails,
        gateways: action.payload.gateways,
        hasError: false,
        pageErrors: [],
      };
    case constants.PROXY_GATEWAY_GET_ERROR:
      return {
        ...state,
        gatewayDetailsLoading: false,
        isLoading: false,
        gatewayDetails: {},
        gateways: [],
        hasError: true,
        pageErrors: action.payload,
      };
    case constants.PROXY_CONFIG_UPDATE_NEW_SYNC_SUCCESS:
      return {
        ...state,
        proxyDetails: {
          ...state.proxyDetails, config: { useNewAutoSync: true },
        },
        hasError: false,
        pageErrors: [],
      };
    case constants.PROXY_CONFIG_UPDATE_NEW_SYNC_ERROR:
      return {
        ...state,
        hasError: true,
        proxyDetails: {
          ...state.proxyDetails, config: { useNewAutoSync: false },
        },
        pageErrors: action.payload,
      };
    case constants.PROXY_APIS_GET_REQUEST:
      return {
        ...state,
        proxyApisLoading: true,
        hasError: false,
        pageErrors: [],
      };
    case constants.PROXY_APIS_GET_SUCCESS:
      return {
        ...state,
        proxyApis: {
          apis: get(action.payload, 'apis'),
          apisPendingDeployment: get(action.payload, 'apisPendingDeployment'),
          apisDeployed: get(action.payload, 'apisDeployed'),
          apisError: get(action.payload, 'apisError'),
          apisPublishedByPortal: get(action.payload, 'apisPublishedByPortal'),
          apisPublishedByPortalPendingDeployment: get(action.payload, 'apisPublishedByPortalPendingDeployment'),
          apisPublishedByPortalDeployed: get(action.payload, 'apisPublishedByPortalDeployed'),
          apisPublishedByPortalError: get(action.payload, 'apisPublishedByPortalError'),
          apisPublishedByGateway: get(action.payload, 'apisPublishedByGateway'),
          apisPublishedByGatewayPendingDeployment: get(action.payload, 'apisPublishedByGatewayPendingDeployment'),
          apisPublishedByGatewayDeployed: get(action.payload, 'apisPublishedByGatewayDeployed'),
          apisPublishedByGatewayError: get(action.payload, 'apisPublishedByGatewayError'),
          apisPendingUndeployment: get(action.payload, 'apisPendingUndeployment'),
          apisPublishedByPortalPendingUndeployment: get(action.payload, 'apisPublishedByPortalPendingUndeployment'),
          apisPublishedByGatewayPendingUndeployment: get(action.payload, 'apisPublishedByGatewayPendingUndeployment'),
          apisErrorUndeploy: get(action.payload, 'apisErrorUndeploy'),
          apisPublishedByPortalErrorUndeploy: get(action.payload, 'apisPublishedByPortalErrorUndeploy'),
          apisPublishedByGatewayErrorUndeploy: get(action.payload, 'apisPublishedByGatewayErrorUndeploy'),
        },
        proxyApisLoading: false,
        hasError: false,
        pageErrors: [],
      };
    case constants.PROXY_APIS_GET_ERROR:
      return {
        ...state,
        proxyApis: {
          apis: 0,
          apisPendingDeployment: 0,
          apisDeployed: 0,
          apisError: 0,
          apisPublishedByPortal: 0,
          apisPublishedByPortalPendingDeployment: 0,
          apisPublishedByPortalDeployed: 0,
          apisPublishedByPortalError: 0,
          apisPublishedByGateway: 0,
          apisPublishedByGatewayPendingDeployment: 0,
          apisPublishedByGatewayDeployed: 0,
          apisPublishedByGatewayError: 0,
        },
        proxyApisLoading: false,
        hasError: true,
        pageErrors: action.payload,
      };
    case constants.API_KEYS_COUNT_GET_REQUEST:
      return {
        ...state,
        apiKeysLoading: true,
        hasError: false,
        pageErrors: [],
      };
    case constants.API_KEYS_COUNT_GET_SUCCESS:
      return {
        ...state,
        apiKeysCount: action.payload.count,
        apiKeysLoading: false,
        hasError: false,
        pageErrors: [],
      };
    case constants.API_KEYS_COUNT_GET_ERROR:
      return {
        ...state,
        apiKeysCount: {},
        apiKeysLoading: false,
        hasError: true,
        pageErrors: action.payload,
      };
    case constants.APIS_GET_SUCCESS:
      return {
        ...state,
        apis: {
          apis: get(action.payload, 'apis'),
          apisPublishedByPortal: get(action.payload, 'apisPublishedByPortal'),
          apisPublishedByGateway: get(action.payload, 'apisPublishedByGateway'),
        },
        proxyApisLoading: false,
        hasError: false,
        pageErrors: [],
      };
    case constants.APIS_GET_ERROR:
      return {
        ...state,
        apis: {
          apis: {},
          apisPublishedByPortal: {},
          apisPublishedByGateway: {},
        },
        proxyApisLoading: false,
        hasError: true,
        pageErrors: action.payload,
      };
    case constants.ACCOUNT_PLANS_GET_SUCCESS:
      return {
        ...state,
        accountPlans: action.payload,
        hasError: false,
        pageErrors: [],
      };
    case constants.ACCOUNT_PLANS_GET_ERROR:
      return {
        ...state,
        accountPlans: {},
        hasError: true,
        pageErrors: action.payload,
      };
    case constants.API_PLANS_GET_SUCCESS:
      return {
        ...state,
        apiPlans: action.payload,
        hasError: false,
        pageErrors: [],
      };
    case constants.API_PLANS_GET_ERROR:
      return {
        ...state,
        apiPlans: {},
        hasError: true,
        pageErrors: action.payload,
      };
    case constants.PROXY_ORGANIZATIONS_GET_SUCCESS:
      return {
        ...state,
        organizations: action.payload,
        hasError: false,
        pageErrors: [],
      };
    case constants.PROXY_ORGANIZATIONS_GET_ERROR:
      return {
        ...state,
        organizations: [],
        hasError: true,
        pageErrors: action.payload,
      };
    case constants.PROXY_APIS_LIST_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        pageErrors: [],
        apisList: action.payload,
      };
    case constants.PROXY_APIS_LIST_GET_ERROR:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        pageErrors: action.payload,
        apisList:  {
          totalPages: 1,
          totalElements: 0,
          results: [],
        },
      };
    case constants.PROXY_APIS_KEYS_LIST_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        pageErrors: [],
        keysList: action.payload,
      };
    case constants.PROXY_APIS_KEYS_LIST_GET_ERROR:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        pageErrors: action.payload,
        keysList: {
          totalPages: 1,
          totalElements: 0,
          results: [],
        },
      };
    case constants.PROXY_APIS_KEYS_COUNT_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        pageErrors: [],
        apiKeys: action.payload,
      };
    case constants.PROXY_APIS_KEYS_COUNT_GET_ERROR:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        pageErrors: action.payload,
        apiKeys: {},
      };
    default:
      return state;
  }
}

export const getUpdateProxyOrgsStatus = (state) => get(state, 'apiProxy.updateProxyOrgsStatus');
export const getIsLoading = (state) => get(state, 'proxy.isLoading');

export const getProxy = (state) => get(state, 'proxy.proxy');
export const getProxyDetails = (state) => get(state, 'proxy.proxyDetails');
export const getProxyDetailsBulkDeploymentStatus = (state) => get(state, 'proxy.proxyDetails.bulkDeploymentStatus');
export const getProxyDetailsBulkApiKeyDeploymentStatus = (state) => get(state, 'proxy.proxyDetails.apiKeyBulkDeploymentStatus');

export const getProxyGatewayDetailsLoading = (state) => get(state, 'proxy.gatewayDetailsLoading');
export const getProxyGatewayDetails = (state) => get(state, 'proxy.gatewayDetails');
export const getParsedProxyGatewayDetails = (state) => {
  const proxyGatewayDetails = getProxyGatewayDetails(state);
  return getParsedGatewayDetails(proxyGatewayDetails);
}
export const getProxyGateways = (state) => get(state, 'proxy.gateways');

export const getIsProxyDeleteSuccess = state => get(state, 'proxy.isProxyDeleteSuccess');
export const getDeleteProxyErrors = state => get(state, 'proxy.deleteProxyErrors');

export const getProxyApis = (state) => get(state, 'proxy.proxyApis');
export const getIsProxyApisLoading = (state) => get(state, 'proxy.proxyApisLoading');

export const getProxyOrganizations = (state) => get(state, 'proxy.organizations');

export const getApis = (state) => get(state, 'proxy.apis');

export const getApiKeysCount = (state) => get(state, 'proxy.apiKeysCount');
export const getIsApiKeysLoading = (state) => get(state, 'proxy.apiKeysLoading');

export const getAccountPlans = (state) => get(state, 'proxy.accountPlans');

export const getApiPlans = (state) => get(state, 'proxy.apiPlans');

export const getHasError = (state) => get(state, 'proxy.hasError');
export const getPageErrors = (state) => get(state, 'proxy.pageErrors');


export const getApisListTotalPages = (state) => get(state, 'proxy.apisList.totalPages');
export const getApisListTotalElements = (state) => get(state, 'proxy.apisList.totalElements');
export const getApisListResults = (state) => get(state, 'proxy.apisList.results');


export const getKeysListTotalPages = (state) => get(state, 'proxy.keysList.totalPages');
export const getKeysListTotalElements = (state) => get(state, 'proxy.keysList.totalElements');
export const getKeysListResults = (state) => get(state, 'proxy.keysList.results');

export const getApiKeys = (state) => get(state, 'proxy.apiKeys');




// WEBPACK FOOTER //
// ./src/reducers/proxy/index.js